<ng-container class="report-custom-container">
  <app-report-select
    [title]="'Reporte de compras'"
    [hidePreview]="true"
    [hidePrint]="true"
    [disabled]="form.invalid || !dataRequested || dataSource.data.length === 0"
    (pdfClicked)="handleGenerateReport()"
    (excelClicked)="handleGenerateExcel()"
  >
    <div slot="content" class="tw-flex tw-flex-col tw-gap-3 tw-px-[10px]">
      <form [formGroup]="form" class="tw-flex tw-flex-col tw-gap-3">
        <div class="tw-flex tw-flex-row tw-gap-3">
          <section>
            <div class="tw-pl-2 tw-mb-2 tw-text-primary tw-font-bold tw-text-[0.7rem] tw-uppercase">Centro</div>
            <app-form-field
              class="
                tw-w-40
                [&_mat-form-field]:!tw-mb-0 [&_mat-form-field]:!tw-h-fit
                [&_mat-form-field_.mat-mdc-input-element]:tw-translate-y-[3px]
              " 
              [type]="'select'"
              label="Selecciona el centro"
              [fieldControl]="form.controls['selectedInstitution'] | asFormControl"
              [options]="selectOptionsInsitutions"
              [multipleSelect]="false">
            </app-form-field>
          </section>

          <section>
            <div class="tw-pl-2 tw-mb-2 tw-text-primary tw-font-bold tw-text-[0.7rem] tw-uppercase">Fecha</div>

            <div class="tw-flex tw-flex-row tw-gap-3">
              <app-form-field
                class="
                  tw-w-40
                  [&_mat-form-field]:!tw-mb-0 [&_mat-form-field]:!tw-h-fit
                  [&_mat-form-field_.mat-mdc-input-element]:tw-translate-y-[3px]
                "
                [type]="'date'"
                label="Desde"
                [fieldControl]="form.controls['fromDate'] | asFormControl"
                [minDate]="minDate"
                [maxDate]="maxDateFrom"
                >
              </app-form-field>

              <app-form-field
                class="
                  tw-w-40
                  [&_mat-form-field]:!tw-mb-0 [&_mat-form-field]:!tw-h-fit
                  [&_mat-form-field_.mat-mdc-input-element]:tw-translate-y-[3px]
                "
                [type]="'date'"
                label="Hasta"
                [fieldControl]="form.controls['toDate'] | asFormControl"
                [minDate]="minDateTo"
                >
              </app-form-field>
            </div>
          </section>

          <section class="tw-flex tw-items-end">
            <button 
              mat-raised-button color="primary" 
              class="!tw-h-[38px]"
              [disabled]="form.invalid"
              (click)="requestData()"
            >
              <mat-icon>search</mat-icon>
              Obtener datos
            </button>
          </section>
        </div>

        <section class="tw-w-full tw-flex tw-flex-row tw-gap-3" *ngIf="dataRequested && dataSource.data.length > 0">
          <app-form-field
            class="tw-w-56"
            [type]="'text'"
            [fieldControl]="form.controls['filter'] | asFormControl"
            [label]="'Filtrar'"
          >
          </app-form-field>

          <app-form-field
            class="
              tw-w-56
              [&_mat-form-field]:!tw-mb-0 [&_mat-form-field]:!tw-h-fit
              [&_mat-form-field_.mat-mdc-input-element]:tw-translate-y-[3px]
            "
            [type]="'select'"
            [label]="'Proveedor'"
            [fieldControl]="form.controls['selectedProveedor'] | asFormControl"
            [options]="selectOptionsProveedores"
            [multipleSelect]="false"
          >
          </app-form-field>
        </section>
      </form>

      <div #list class="tw-w-full tw-h-[calc(100%-0.5rem)] tw-overflow-y-auto tw-rounded-lg">
        <table
          mat-table
          [dataSource]="dataSource"
          matSort
          class="!tw-bg-white tw-rounded-lg"
          *ngIf="dataRequested"
        >
          <!-- InstitutionId -->
          <ng-container matColumnDef="InstitutionId">
            <th
              mat-header-cell
              mat-sort-header
              *matHeaderCellDef
              class="!tw-text-white !tw-bg-primary !tw-border-none !tw-rounded-l-lg"
            >
              Centro
            </th>
            <td mat-cell *matCellDef="let element" class="!tw-border-primary/10 tw-text-sm !tw-p-2">
              <span class="tw-font-medium">{{ element.InstitutionId || '-' }}</span>
            </td>
          </ng-container>

          <!-- DrugId -->
          <ng-container matColumnDef="DrugId">
            <th mat-header-cell mat-sort-header *matHeaderCellDef class="!tw-text-white !tw-bg-primary !tw-border-none"> CN </th>
            <td mat-cell *matCellDef="let element" class="!tw-border-primary/10 tw-text-sm !tw-p-2">
              <span class="tw-font-medium">{{ element.DrugId || '-' }}</span>
            </td>
          </ng-container>

          <!-- NombreMedicamento -->
          <ng-container matColumnDef="NombreMedicamento">
            <th
              mat-header-cell
              mat-sort-header
              *matHeaderCellDef
              class="!tw-text-white !tw-bg-primary !tw-border-none !tw-w-96"
            >
              Medicamento
            </th>
            <td mat-cell *matCellDef="let element" class="!tw-border-primary/10 tw-text-sm !tw-p-2">
              <span class="tw-line-clamp-2">{{ element.NombreMedicamento || '-' }}</span>
            </td>
          </ng-container>

          <!-- PVLN -->
          <ng-container matColumnDef="PVLN">
            <th mat-header-cell mat-sort-header *matHeaderCellDef class="!tw-text-white !tw-bg-primary !tw-border-none"> PVLN </th>
            <td mat-cell *matCellDef="let element" class="!tw-border-primary/10 tw-text-sm !tw-p-2">
              <span>{{ element.PVLN != null ? (element.PVLN | number:'1.2-2') + '€' : '-' }}</span>
            </td>
          </ng-container>

          <!-- Unidades -->
          <ng-container matColumnDef="Unidades">
            <th mat-header-cell mat-sort-header *matHeaderCellDef class="!tw-text-white !tw-bg-primary !tw-border-none"> Unidades </th>
            <td mat-cell *matCellDef="let element" class="!tw-border-primary/10 tw-text-sm !tw-p-2">
              <span>{{ element.Unidades || '-' }}</span>
            </td>
          </ng-container>

          <!-- Quantity -->
          <ng-container matColumnDef="Quantity">
            <th mat-header-cell mat-sort-header *matHeaderCellDef class="!tw-text-white !tw-bg-primary !tw-border-none"> Cantidad </th>
            <td mat-cell *matCellDef="let element" class="!tw-border-primary/10 tw-text-sm !tw-p-2">
              <span>{{ element.Quantity || '0' }}</span>
            </td>
          </ng-container>

          <!-- Stock -->
          <ng-container matColumnDef="Stock">
            <th mat-header-cell mat-sort-header *matHeaderCellDef class="!tw-text-white !tw-bg-primary !tw-border-none"> Stock </th>
            <td mat-cell *matCellDef="let element" class="!tw-border-primary/10 tw-text-sm !tw-p-2">
              <span>{{ element.Stock || '0' }}</span>
            </td>
          </ng-container>

          <!-- Poveedor -->
          <ng-container matColumnDef="Poveedor">
            <th mat-header-cell mat-sort-header *matHeaderCellDef class="!tw-text-white !tw-bg-primary !tw-border-none !tw-w-64"> Proveedor </th>
            <td mat-cell *matCellDef="let element" class="!tw-border-primary/10 tw-text-sm !tw-p-2">
              <span>{{ element.Poveedor || '-' }}</span>
            </td>
          </ng-container>

          <!-- Cajas -->
          <ng-container matColumnDef="Cajas">
            <th mat-header-cell mat-sort-header *matHeaderCellDef class="!tw-text-white !tw-bg-primary !tw-border-none"> Cajas </th>
            <td mat-cell *matCellDef="let element" class="!tw-border-primary/10 tw-text-sm !tw-p-2">
              <span>{{ element.Cajas || '-' }}</span>
            </td>
          </ng-container>

          <tr
            mat-header-row
            *matHeaderRowDef="displayedColumns; sticky: true;"
            class="!tw-h-10 tw-text-xs !tw-bg-transparent"
          ></tr>
          <tr
            mat-row
            *matRowDef="let row; columns: displayedColumns;"
            class="hover:!tw-bg-primary/5"
          ></tr>
        <!-- Fila cuando no hay resultados -->
        <tr
          *matNoDataRow
          class="hover:!tw-bg-transparent"
        >
          <td
            [attr.colspan]="displayedColumns.length"
            class="!tw-text-center !tw-py-8 !tw-text-gray-500 !tw-border-none"
          >
            <div class="tw-flex tw-flex-col tw-items-center tw-gap-2">
              <mat-icon class="!tw-w-[48px] !tw-h-[48px] !tw-text-[48px] tw-flex tw-items-center tw-justify-center tw-text-gray-400">search_off</mat-icon>
              <span class="tw-text-base tw-font-medium">No se encontraron resultados</span>
              <span class="tw-text-sm tw-text-gray-400">Intenta ajustar los filtros de búsqueda</span>
            </div>
          </td>
        </tr>
        </table>
      </div>
    </div>
  </app-report-select>
</ng-container>